/**
 * File: bfwt-custom-tabs.js
 * Purpose: Provides universal functionality for tabbed components. (Vanilla JS Version)
 */
(function () {
  'use strict';

  function initializeTabs(scope) {
    const searchContext = scope || document;
    const tabNavs = searchContext.querySelectorAll(
      '.bfwt-custom-tabs:not(.bfwt-tabs-initialized)'
    );

    tabNavs.forEach((tabNav) => {
      const container = tabNav.parentElement;
      if (!container) return;

      const tabContent = container.querySelector('.bfwt-tab-content');
      if (!tabContent) return;

      const tabLinks = tabNav.querySelectorAll('a');
      if (tabLinks.length === 0) return;

      tabNav.classList.add('bfwt-tabs-initialized');

      // ARIA: tablist, tab, tabpanel
      tabNav.setAttribute('role', 'tablist');
      tabLinks.forEach((link, idx) => {
        const contentId = link.getAttribute('href');
        if (!contentId || contentId === '#') return;
        const pane = tabContent.querySelector(contentId);
        if (!pane) return;
        const tabId =
          link.id ||
          'bfwt-tab-' + idx + '-' + Math.random().toString(36).slice(2, 8);
        if (!link.id) link.id = tabId;
        link.setAttribute('role', 'tab');
        link.setAttribute(
          'aria-selected',
          link.parentElement && link.parentElement.classList.contains('active')
            ? 'true'
            : 'false'
        );
        link.setAttribute('aria-controls', contentId.slice(1));
        pane.setAttribute('role', 'tabpanel');
        pane.setAttribute('aria-labelledby', tabId);
      });

      tabNav.addEventListener('click', function (e) {
        const link = e.target.closest('a');
        if (!link) return;

        e.preventDefault();

        const listItem = link.parentElement;
        if (listItem.classList.contains('active')) {
          return;
        }

        const activeTab = tabNav.querySelector('li.active');
        if (activeTab) activeTab.classList.remove('active');
        tabNav
          .querySelectorAll('a[role="tab"]')
          .forEach((t) => t.setAttribute('aria-selected', 'false'));

        const activePane = tabContent.querySelector('.bfwt-tab-pane.active');
        if (activePane) activePane.classList.remove('active');

        listItem.classList.add('active');
        link.setAttribute('aria-selected', 'true');
        const contentId = link.getAttribute('href');
        const newActivePane = tabContent.querySelector(contentId);
        if (newActivePane) {
          newActivePane.classList.add('active');
        }
      });

      // Set initial tab based on URL hash
      const hash = window.location.hash;
      if (hash) {
        const link = tabNav.querySelector(`a[href="${hash}"]`);
        if (link) {
          // Deactivate any default active tabs
          const activeTab = tabNav.querySelector('li.active');
          if (activeTab) activeTab.classList.remove('active');
          const activePane = tabContent.querySelector('.bfwt-tab-pane.active');
          if (activePane) activePane.classList.remove('active');

          // Activate the tab from the hash
          link.parentElement.classList.add('active');
          const newActivePane = tabContent.querySelector(hash);
          if (newActivePane) {
            newActivePane.classList.add('active');
          }
        }
      } else if (!tabNav.querySelector('li.active') && tabLinks.length > 0) {
        // If no hash and no tab is active, activate the first one
        const firstTab = tabLinks[0].parentElement;
        const firstPaneId = tabLinks[0].getAttribute('href');
        const firstPane = tabContent.querySelector(firstPaneId);

        if (firstTab && firstPane) {
          firstTab.classList.add('active');
          firstPane.classList.add('active');
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => initializeTabs());

  document.addEventListener('bfwt:content-loaded', (e) => {
    if (e.target) {
      initializeTabs(e.target);
    }
  });
})();
